export default "__VITE_ASSET__CPJERj4U__"